import React, {Component} from "react"
import {Col, Row} from "react-bootstrap"
import scrollIntoView from "scroll-into-view-if-needed"

import {CompanyNewsTileConfig} from "@irati/types"
import {Description, Url} from "@irati-web/fields/companyNews"

import Icon from "../Template/Icon"
import TemplateTitle from "../Template/Title"
import TemplateFindOutMore from "../Template/FindOutMore"
import {StyledTemplatesCol, StyledTemplate, StyledSvgCard} from "../Template/styled"

interface Props {
  companyNewsTileConfig: CompanyNewsTileConfig
  updateContent: (companyNewsTileConfig: CompanyNewsTileConfig) => void
}

interface CompanyNewsTileTemplate {
  backgroundColor: string
  templateIcon: string
  templateText: string
}

const templateLibrary: CompanyNewsTileTemplate[] = [
  {
    backgroundColor: "#EE6352",
    templateIcon: "calendar",
    templateText: "platform.homepage.companyNews.template.companyCalendar"
  },
  {
    backgroundColor: "#7856E7",
    templateIcon: "announcement",
    templateText: "platform.homepage.companyNews.template.announcement"
  },
  {
    backgroundColor: "#EAC900",
    templateIcon: "event",
    templateText: "platform.homepage.companyNews.template.companyEvent"
  },
  {
    backgroundColor: "#21A0A0",
    templateIcon: "values",
    templateText: "platform.homepage.companyNews.template.companyValues"
  },
  {
    backgroundColor: "#F1BB6C",
    templateIcon: "party",
    templateText: "platform.homepage.companyNews.template.party"
  },
  {
    backgroundColor: "#FF5555",
    templateIcon: "people",
    templateText: "platform.homepage.companyNews.template.employeeReferral"
  },
  {
    backgroundColor: "#95CDC7",
    templateIcon: "play-video",
    templateText: "platform.homepage.companyNews.template.perkbox"
  },
  {
    backgroundColor: "#B4BAC6",
    templateIcon: "reminder",
    templateText: "platform.homepage.companyNews.template.reminder"
  },
  {
    backgroundColor: "#0DB690",
    templateIcon: "clipboard",
    templateText: "platform.homepage.companyNews.template.volunteer"
  },
  {
    backgroundColor: "#00ADEE",
    templateIcon: "blog",
    templateText: "platform.homepage.companyNews.template.companyBlog"
  },
  {
    backgroundColor: "#4A90E2",
    templateIcon: "clock",
    templateText: "platform.homepage.companyNews.template.extraShifts"
  },
  {
    backgroundColor: "#4A7BB4",
    templateIcon: "newsletter",
    templateText: "platform.homepage.companyNews.template.newsletter"
  }
]

class NewTemplateTileForm extends Component<Props> {
  componentDidMount() {
    const {companyNewsTileConfig, updateContent} = this.props
    if (!companyNewsTileConfig.backgroundColor) {
      const defaultTemplate = templateLibrary[0]
      updateContent(Object.assign({}, companyNewsTileConfig, {...defaultTemplate}))
    } else {
      // @ts-ignore
      scrollIntoView(document.getElementById(`id-${companyNewsTileConfig.templateIcon}`), {scrollMode: "if-needed"})
    }
  }

  render() {
    const {companyNewsTileConfig, updateContent} = this.props

    return (
      <Row>
        <StyledTemplatesCol xs={6}>
          {templateLibrary.map((template: CompanyNewsTileTemplate) => (
            <div key={template.backgroundColor} id={`id-${template.templateIcon}`}>
              <StyledSvgCard
                color={template.backgroundColor}
                isSelected={companyNewsTileConfig.backgroundColor === template.backgroundColor}
                onClick={() => {
                  updateContent(Object.assign({}, companyNewsTileConfig, {...template}))
                }}>
                <StyledTemplate>
                  <Icon icon={template.templateIcon} />
                  {template?.templateText && <TemplateTitle templateText={template.templateText} />}
                  <TemplateFindOutMore />
                </StyledTemplate>
              </StyledSvgCard>
            </div>
          ))}
        </StyledTemplatesCol>
        <Col xs={6}>
          <Description
            onChange={(message: string) => {
              const updatedContent = Object.assign({}, companyNewsTileConfig, {message})
              updateContent(updatedContent)
            }}
            value={companyNewsTileConfig.message}
          />
          <Url
            onChange={(url: string) => {
              updateContent(Object.assign({}, companyNewsTileConfig, {url}))
            }}
            value={companyNewsTileConfig.url}
          />
        </Col>
      </Row>
    )
  }
}

export default NewTemplateTileForm
